import React, { useLayoutEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { DefaultMap, DefaultMarker } from "./default-map";

const BusinessVipMap: React.FC<{
  name: string;
  address: string;
  zipcode: string;
  city: string;
  latitude: number;
  longitude: number;
}> = (props) => {
  const [markers, setMarkers] = useState<DefaultMarker[]>();

  useLayoutEffect(() => {
    const marker: DefaultMarker[] = [
      {
        data: [props.name, props.address, `${props.zipcode} ${props.city}`],
        position: [props.latitude, props.longitude],
        url: "",
      },
    ];

    setMarkers(marker);
  }, []);

  return (
    <>
      {markers && markers.length > 0 && (
        <DefaultMap
          markers={markers}
          latitude={props.latitude}
          longitude={props.longitude}
        />
      )}
    </>
  );
};

const elements = document.getElementsByTagName("business-vip-map");
if (elements.length == 1) {
  const element = elements[0];
  const root = createRoot(element);
  root.render(
    <BusinessVipMap
      name={element.getAttribute("data-business-name")!.valueOf()}
      address={element.getAttribute("data-business-address")!.valueOf()}
      zipcode={element.getAttribute("data-business-zipcode")!.valueOf()}
      city={element.getAttribute("data-business-city")!.valueOf()}
      latitude={Number(element.getAttribute("data-latitude")!.valueOf())}
      longitude={Number(element.getAttribute("data-longitude")!.valueOf())}
    />
  );
}
